module.exports = __webpack_public_path__ + "media/stashboard/get-it-on-google-play-df23d53c.png";